module.exports = "/images/Create your submittal log - 1.jpg";